import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data-test-id", "isLoading", "resetDays", "totalUsage", "usageLimit", "hasLowCredits"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CreditTile } from './CreditTile/CreditTile';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UsageCreditsUsed = _ref => {
  let {
      'data-test-id': dataTestId = 'usage-credits-used',
      isLoading,
      resetDays = 0,
      totalUsage,
      usageLimit,
      hasLowCredits
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CreditTile, Object.assign({
    isLoading: isLoading
  }, rest, {
    children: [/*#__PURE__*/_jsx(CreditTile.Count, {
      "data-test-id": dataTestId,
      hasLowCredits: hasLowCredits,
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "hubSpotCredits.used",
        options: {
          totalUsage,
          usageLimit
        }
      })
    }), /*#__PURE__*/_jsx(CreditTile.Label, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubSpotCredits.titleMonthly"
      })
    }), /*#__PURE__*/_jsx(CreditTile.Reset, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "hubSpotCredits.resetDays",
        options: {
          count: resetDays
        }
      })
    })]
  }));
};